
import { ReactComponent as QueryIcon } from '../../res/query.svg'

export const HeaderLogo = () => {
  return <div id="headerLogo"></div>;
}